import { createAsyncThunk } from "@reduxjs/toolkit";
import { Base_URL, ApiCall } from "../../Common/Path";

//Strategy Calls

export const GetStrategyTable = createAsyncThunk("StrategyTable", async () => {
  try {
    const response = await ApiCall(
      `${Base_URL}/strategy/strategies-for-dashboard`, '','get'
    );
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
});


//Custodian Calls


export const Strategyperformancegraph = createAsyncThunk(
  "Strategyperformancegraph",
  async (id) => {
    try {
      const response = await ApiCall(
        `${Base_URL}/strategy/graph-data?strategyId=${id}`, '', 'get'
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);

export const GetAllUserStrategies = createAsyncThunk(
  "GetAllUserStrategies",
  async (params = {}) => {
    try {
      const {  userEmail = '' } = params;
      
      // Build query parameters
      const queryParams = new URLSearchParams({
        ...(userEmail && { userEmail })
      });
      
      const response = await ApiCall(
        `${Base_URL}/strategies/admin/all-user-strategies?${queryParams.toString()}`,
        '',
        'get'
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);


// Strategy Users 
export const PatchUserStrategies = createAsyncThunk(
  "PatchUserStrategies",
  async (values) => {
    try {
      const response = await ApiCall(
        `${Base_URL}/strategies/users`,
        values,
        "PATCH"
      );
      return response;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  }
);